import Location from "./geo/Location";
export default class Destination {
  constructor({
    id,
    distance,
    location,
    postsCount,
    totalPostsCount,
    creatorTotalPostsCount,
    name,
    description,
    isHighlighted,
    mainPictureUrl,
    mainPicture,
    category,
    routeUrl
  } = {}) {
    this.id = id || 0;
    this.distance = distance;
    this.location = new Location(location) || new Location();
    this.postsCount = postsCount || NaN;
    this.totalPostsCount = totalPostsCount || NaN;
    this.creatorTotalPostsCount = creatorTotalPostsCount || NaN;
    this.name = name || "";
    this.description = description || "";
    this.isHighlighted = isHighlighted || "";
    this.mainPictureUrl = mainPictureUrl || "";
    this.mainPicture = mainPicture || null;
    this.category = category || {
      id: -1,
      nameEn: "poi",
      nameFr: "point d'intérêt"
    };
    this.routeUrl = routeUrl || "";
  }
  getDataForCreateOrEditPost() {
    return this.location.getDataForCreateOrEditPost();
  }
}
